export default {
      id: "Icon--tags-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--tags",
      toString: function () {
        return this.url;
      }
    }